"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteRegisterReducer = exports.siteRegisterActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const REGISTER = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'SiteRegister';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_ENTRY: REGISTER + 'SetEntry',
  SET_ENTRIES: REGISTER + 'SetEntries',
  SET_CONTENT: REGISTER + 'SetContent',
  CHANGE_CONDITION: REGISTER + 'ChangeCondition',
  CHANGE_AREA_SITE: REGISTER + 'ChangeAreaSite',
  CLEAR: REGISTER + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  ENTRY: 'entry',
  UPDATE: 'update',
  RESULT: 'result'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.ENTRY,
  entries: {
    buildingNo: '',
    buildingNm: '',
    siteNo: '',
    siteNm: '',
    tdfkCd: '',
    address: '',
    siteFunc: [],
    kaishaCd: '',
    kaishaNm: '',
    soshikiCd: [],
    soshikiNm: [],
    siteTypeCd: '',
    areaCd: '',
    areaNm: '',
    workersCnt: '',
    floors: '',
    totalStories: '',
    communicationMeans: [],
    communicationOther: '',
    storedFood: '',
    storedFoodNote: '',
    storedDrink: '',
    storedDrinkNote: '',
    warehouseArticleNote: '',
    warehouseInTankNote: '',
    lastUpdNm: '',
    lastUpdDt: '',
    updId: '',
    updDt: ''
  }
};

/**
 * アクション定義
 */
const siteRegisterActions = exports.siteRegisterActions = (0, _reduxActions.createActions)({
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      data: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_AREA_SITE]: function () {
    return {
      areaCd: arguments.length <= 0 ? undefined : arguments[0],
      areaNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const siteRegisterReducer = exports.siteRegisterReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.data
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.CHANGE_CONDITION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.CHANGE_AREA_SITE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        areaCd: action.payload.areaCd,
        areaNm: action.payload.areaNm
      })
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);